import {SortSchema} from '@cypro/ui/schemas'
import * as z from 'zod'
import {ConsumableCategory} from '@cypro/engine/database/schema'

export const NewConsumablePageSearchSchema = z.object({
  consumableId: z.uuidv7().optional(),
})

export const ConsumablesSearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      status: z.array(z.string()).optional(),
      categories: z.array(ConsumableCategory).optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

export const ConsumableFormSchema = z.object({
  name: z.string().trim().nonempty(),
  description: z.string(),
  barcode: z.string(),
  nationalId: z.string(),
  category: ConsumableCategory.nonoptional(),
  unitsPerPackage: z.int().positive(),
  minimumStock: z.int().positive(),
  machineId: z.string(),
})
export type ConsumableFormSchema = z.infer<typeof ConsumableFormSchema>
